import { createRef, useEffect, useState } from "react";
import { add, format } from "date-fns";
import { TiMessages } from 'react-icons/ti'
import { MdOutlineAlternateEmail, MdContentCopy } from 'react-icons/md'
import { TabelaAcordoParcelas } from "../tabela";
import { Button } from "../../../../../../../../generics/button";
import { usePropostas } from "../../../../../../../../../context/PropostasContext";
import { useBoleto } from "../../../../../../../../../context/BoletoContext";
import { useDividas } from "../../../../../../../../../context/DividasContext";
import { copyImageToClipboard } from "copy-image-clipboard";


interface ResumoAcordoAccordionProps {
  formaPag: string;
  vencimento: string;
}

export const ResumoAcordoAccordion = ({ formaPag, vencimento }: ResumoAcordoAccordionProps) => {
  const { selectedProposta, canalEnvio, selectedContrato } = usePropostas()
  const { selectedCredor, devedor } = useDividas()
  const { enviarBoleto, boleto } = useBoleto()

  const ref = createRef<HTMLDivElement>();

  const [canal, setCanal] = useState<{ canal: string; destino: string }[]>([])


  useEffect(() => {
    if (canalEnvio.canalrecebimento === 'email;sms') {
      const [canalEmail, canalSms] = canalEnvio.destinorecebimento.split(';')
      setCanal([
        {
          canal: 'email',
          destino: canalEmail
        },
        {
          canal: 'sms',
          destino: canalSms
        },
      ])
    } else {
      setCanal([{ canal: canalEnvio.canalrecebimento, destino: canalEnvio.destinorecebimento }])
    }
  }, [canalEnvio])

  function formatDate(date: string) {
    if (date) {
      const [dia, mes, ano] = date?.split('/')
      const dataFormatada = `${mes}/${dia}/${ano}`
      const dataParaAdd = new Date(dataFormatada)
      const dataAdd = add(dataParaAdd, { days: 30 })
      return format(dataAdd, 'dd/MM/yyyy')
    }
  }

  function formatarTelefone(telefone: string) {
    telefone = telefone.replace(/\D/g, '');
    telefone = telefone.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    return telefone;
  }


  function goToOpeningAccordion() {
    const element = document.getElementById("acordo");
    if (element) {
      document.getElementById("acordo")?.setAttribute("open", "true");
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
  async function concluirAcordo() {
    const data = {
      url: selectedCredor.url_ws,
      contrato: selectedContrato ? selectedContrato : selectedProposta.contrato,
      cpf_cnpj: devedor?.cpf_cnpj || '',
      codcredor: String(selectedCredor.credor_crm),
      idproposta: selectedContrato ? '' : selectedProposta.id,
      modo: selectedContrato ? '0' : '1',
      canalrecebimento: canalEnvio.canalrecebimento,
      destinorecebimento: canalEnvio.destinorecebimento,
      vencimento: vencimento,
      formapagamento: formaPag === 'Boleto' ? '1' : '4',
      app: 'ACIONA_WEB'
    }
    await enviarBoleto(data)
  }

  async function handleAcordo() {
    await concluirAcordo();
    goToOpeningAccordion();
  }

  async function copiarResumo() {


  }

  return (
    <details
      id="resumo"
      className={`mb-3 w-full border border-gray-300 bg-white ${!canalEnvio.canalrecebimento && !selectedProposta.id && 'pointer-events-none'}`}
    >
      <summary className="flex w-full cursor-pointer justify-between bg-white px-4 py-3 text-xl font-medium text-gray-800 after:content-['+']">
        Resumo do Acordo
      </summary>


      {
        ((canalEnvio.canalrecebimento && selectedProposta.id) || (canalEnvio.canalrecebimento && selectedContrato)) && (
          <div className="px-4 py-2">

            <div ref={ref} className="px-4 py-2">
              <div className="flex w-full gap-4 ">
                {
                  selectedProposta?.id && !selectedContrato && (
                    <div className="flex h-full w-1/2 flex-col items-center">
                      <p className="font-medium text-primary ">
                        Operações envolvidas no acordo
                      </p>
                      <div>
                        <TabelaAcordoParcelas prestacoes={selectedProposta.prestacoes} />
                      </div>
                    </div>
                  )
                }

                <div className={`flex  ${!selectedContrato && selectedProposta?.id ? 'w-1/2' : 'w-full'}  flex-col items-center justify-center rounded bg-gray-100 p-4 text-xs`}>
                  <p className="font-medium text-primary ">Detalhes da negociação</p>
                  <div className=" text-right">
                    <div className="my-4 grid grid-cols-2 gap-4  text-gray-800">
                      <strong>Tipo de negociação: </strong>
                      <p>{selectedProposta?.tipo === 'AV' ? 'Á vista' : 'Á prazo'}</p>

                      <strong>Forma de pagamento: </strong>
                      <p>{formaPag}</p>

                      {
                        selectedProposta?.tipo === 'AP' && (
                          <>
                            <strong>Valor da entrada: </strong>
                            <p>R$ {selectedProposta?.valorEntrada}</p>
                          </>
                        )
                      }

                      {
                        selectedProposta?.tipo === 'AP' && (
                          <>
                            <strong>Demais parcelas: </strong>
                            <p>{selectedProposta?.quantidadeParcelas}x R$ {selectedProposta?.valorParcela}</p>
                          </>
                        )
                      }

                      <strong>Vencimento {selectedProposta?.tipo === 'AP' && 'da entrada'} : </strong>
                      <p>{vencimento}</p>

                      {
                        selectedProposta?.tipo === 'AP' && (
                          <>
                            <strong>Vencimento da prox. parcela: </strong>
                            <p>{formatDate(vencimento)}</p>
                          </>
                        )
                      }

                      <strong>Valor atualizado: </strong>
                      <p>R$ {selectedProposta?.valorCorrigido}</p>

                      <strong>Desconto: </strong>
                      <p>R$ {selectedProposta?.valorDesconto}</p>

                      <strong>Total a pagar: </strong>
                      <p>R$ {selectedProposta?.valorTotal}</p>
                    </div>
                  </div>

                  <div className="my-2 flex flex-col text-sm gap-2 border-2 p-4 border-primary rounded-md">
                    <p>Enviaremos seu boleto para os canais cadastrados:</p>
                    {
                      canal.length > 0 && canal.map(envio => (
                        <div className="" key={envio.canal}>
                          <div className="flex items-center  font-bold text-primary ">
                            {
                              envio.canal === 'email' ? (<>
                                <MdOutlineAlternateEmail size={18} className="fill-primary" />
                                <p className="mx-2">E-mail</p>
                              </>) : (<>
                                <TiMessages size={18} className="fill-primary" />
                                <p className="mx-2">SMS</p>
                              </>)
                            }

                          </div>
                          <p>{envio.canal === 'sms' ? formatarTelefone(envio.destino) : envio.destino}</p>
                        </div>
                      ))
                    }

                  </div>
                </div>

              </div>


            </div>


            <div>
              <div className="my-4 flex items-center justify-evenly ">
                {
                  !selectedContrato && selectedProposta?.id && (
                    <div className="flex w-full items-center justify-center">
                      <button className="flex items-center  gap-4  text-primary underline" onClick={copiarResumo}>
                        <MdContentCopy size={24} className="fill-primary" />
                        {/* <img src={copyCodeGreenIcon} alt="" /> */}
                        Copiar resumo
                      </button>
                    </div>
                  )
                }
                {
                  boleto && boleto?.url ? (<></>) : (
                    <Button
                      name="Concluir acordo"
                      width="w-[100%]"
                      onClick={() => {
                        handleAcordo()
                      }}
                    />
                  )
                }
              </div>
            </div>
          </div>
        )
      }
    </details>
  );
};
